import React from 'react'
import Ikona from './IkonaZlecenia'

/**
 * Kafle wyboru jako prawdziwe przyciski radiowe (strzałki, Tab, spacja działają jak w przeglądarce): liczba ofert
 * 3, 6, 9 i „Kto zajmie się sprzętem”. Nic nie jest zaznaczone z góry, gdy `wartosc` jest pusta.
 */
const WyborKafla = ({ nazwa, opcje, wartosc, onZmiana, className, etykieta, blad = false }) => (
  <div className={className} role="radiogroup" aria-label={etykieta} aria-invalid={blad || undefined}>
    {opcje.map((o) => {
      const on = String(wartosc) === String(o.wartosc)
      return (
        <label key={o.wartosc} className={`kafel-wyboru${on ? ' on' : ''}${o.klasa ? ` ${o.klasa}` : ''}`}>
          <input type="radio" name={nazwa} value={o.wartosc} checked={on} onChange={() => onZmiana(o.wartosc)} />
          <span className="kafel-ok" aria-hidden="true"><Ikona nazwa="ok" rozmiar={12} grubosc={3.4} /></span>
          {o.tresc}
        </label>
      )
    })}
  </div>
)

export default WyborKafla
